import {
  Button,
  // NavBar,
  Field,
  // CellGroup,
  Form,
  Popup,
  Cascader,
  // Dialog,
  // Toast,
  Tabs,
  Tab,
  // Row,
  // Col,
  Icon,
  Image,
  Lazyload,
  PullRefresh,
  TreeSelect,
  // Search,
  Card,
  Radio,
  RadioGroup,
  Picker,
  DropdownMenu,
  DropdownItem,
  List,
  Swipe,
  SwipeItem,
  NoticeBar,
  Tag,
  // Area,
  Uploader,
  Cell,
  // Progress,
  // Circle,
  DatePicker,
  // Divider,
  Step,
  Steps,
  Switch,
  Dialog,
  Rate,
  CheckboxGroup,
  Checkbox,
  Divider
} from 'vant'


export default {
  install (app: App) {
    app.component(Card.name, Card)
    app.component(Tag.name, Tag)
    app.component(Divider.name, Divider)
    app.component(Cell.name, Cell)
    app.component(Button.name, Button)
    app.component(Field.name, Field)
    app.component(Form.name, Form)
    app.component(Popup.name, Popup)
    app.component(Cascader.name, Cascader)
    app.component(Tabs.name, Tabs)
    app.component(Tab.name, Tab)
    app.component(Icon.name, Icon)
    app.component(Image.name, Image)
    app.component(Lazyload.name, Lazyload)
    app.component(PullRefresh.name, PullRefresh)
    app.component(TreeSelect.name, TreeSelect)
    app.component(Radio.name, Radio)
    app.component(RadioGroup.name, RadioGroup)
    app.component(Picker.name, Picker)
    app.component(DropdownMenu.name, DropdownMenu)
    app.component(DropdownItem.name, DropdownItem)
    app.component(List.name, List)
    app.component(Swipe.name, Swipe)
    app.component(SwipeItem.name, SwipeItem)
    app.component(NoticeBar.name, NoticeBar)
    app.component(Uploader.name, Uploader)
    app.component(DatePicker.name, DatePicker)
    app.component(Step.name, Step)
    app.component(Steps.name, Steps)
    app.component(Switch.name, Switch)
    app.component(Dialog.name, Dialog)
    app.component(Rate.name, Rate)
    app.component(CheckboxGroup.name, CheckboxGroup)
    app.component(Checkbox.name, Checkbox)


  }
}

